import { lazy } from 'react';

const Home = lazy(() => import('../PAGES/HOME/Home'));
const Temporary = lazy(() => import('../PAGES/COMMON/Service/Temporary'));
const Privacy = lazy(() => import('../PAGES/COMMON/Policy/Privacy/Privacy'));
const QrAttendanceLogin = lazy(() => import('../PAGES/QR/ATTENDANCE/LOGIN/QrAttendanceLogin'));
const QrAttendanceRegist = lazy(() => import('../PAGES/QR/ATTENDANCE/REGIST/QrAttendanceRegist'));
const FitnessResult = lazy(() => import('../PAGES/USERDOJANG/FITNESS/RESULT/FitnessResult'));
const HealthcareHeightChart = lazy(
  () => import('../PAGES/USERDOJANG/HEALTHCARE/HEIGHTCHART/HealthcareHeightChart'),
);
const AccountLogin = lazy(() => import('../PAGES/COMMON/ACCOUNT/LOGIN/AccountLogin'));
const AccountLoginRedirect = lazy(
  () => import('../PAGES/COMMON/ACCOUNT/LOGIN/AccountLoginRedirect'),
);
const AssociationLogin = lazy(() => import('../PAGES/COMMON/AssociationLogin'));
const AssociationSign = lazy(() => import('../PAGES/COMMON/AssociationSign'));
const AssociationLoginAfter = lazy(() => import('../PAGES/COMMON/AssociationLoginAfter'));
const HealthCareHome = lazy(() => import('../PAGES/HOME/HEALTHCARE/HealthCareHome'));
const ApplicationSection = lazy(() => import('../PAGES/HOME/HEALTHCARE/ApplicationSection'));
const AdminHealthCareFormList = lazy(
  () => import('../PAGES/HOME/HEALTHCARE/ADMIN/LIST/AdminHealthCareFormList'),
);
const PaymentHome = lazy(() => import('../PAGES/HOME/PAYMENT/PaymentHome'));
const BillStatusPage = lazy(() => import('../PAGES/USERDOJANG/BILL/CHECK/BillStatusPage'));
const BillResultComponent = lazy(
  () => import('../PAGES/USERDOJANG/BILL/RESULT/BillResultComponent'),
);
const CantAccessPage = lazy(() => import('../PAGES/COMMON/CantAccessPage'));
const AccountSign = lazy(() => import('../PAGES/COMMON/ACCOUNT/SIGN/AccountSign'));
const AccountSignKwanjang = lazy(
  () => import('../PAGES/COMMON/ACCOUNT/SIGN/KWANJANG/AccountSignKwanjang'),
);
const AccountSignSabum = lazy(() => import('../PAGES/COMMON/ACCOUNT/SIGN/SABUM/AccountSignSabum'));
const AccountSignStudent = lazy(
  () => import('../PAGES/COMMON/ACCOUNT/SIGN/STUDENT/AccountSignStudent'),
);
const AccountSignParent = lazy(
  () => import('../PAGES/COMMON/ACCOUNT/SIGN/PARENT/AccountSignParent'),
);
const FindUserName = lazy(() => import('../PAGES/COMMON/ACCOUNT/FIND/FindUserName'));
const FindUserPW = lazy(() => import('../PAGES/COMMON/ACCOUNT/FIND/FindUserPW'));
const SportsentNotice = lazy(() => import('../PAGES/COMMON/SPORTSENT/NOTICE/SportsentNotice'));
const AdminLogin = lazy(() => import('../PAGES/ADMIN/LOGIN/AdminLogin'));
const Invitation = lazy(() => import('../PAGES/COMMON/INVITATION/Invitation'));
const AcceptInvitation = lazy(
  () => import('../PAGES/COMMON/INVITATION/Components/AcceptInvitation'),
);
const MypageAccount = lazy(() => import('../PAGES/USERDOJANG/MYPAGE/ACCOUNT/MypageAccount'));
const MypageResume = lazy(() => import('../PAGES/USERDOJANG/MYPAGE/RESUME/MypageResume'));
const AccountLogout = lazy(() => import('../PAGES/COMMON/ACCOUNT/LOGIN/AccountLogout'));
const PromotionCertificate = lazy(() => import('../PAGES/PROMOTION/PromotionCertificate'));

const TkwTerms = lazy(() => import('../PAGES/COMMON/Terms/TkwTerms'));
const PersonalTerms = lazy(() => import('../PAGES/COMMON/Terms/PersonalTerms'));
const LocationTerms = lazy(() => import('../PAGES/COMMON/Terms/LocationTerms'));
const MarketingTerms = lazy(() => import('../PAGES/COMMON/Terms/MarketingTerms'));

// routes
const commonRoutes = {
  noLayout: [
    // root
    { path: '/', element: <Home /> },
    // account
    { path: '/account/login', element: <AccountLogin /> },
    { path: '/account/login/redirect', element: <AccountLoginRedirect /> },
    { path: '/account/login/association', element: <AssociationLogin /> },
    { path: '/account/login/association/sign', element: <AssociationSign /> },
    { path: '/account/error/access', element: <CantAccessPage /> },
    { path: '/account/login/association/loading', element: <AssociationLoginAfter /> },
    { path: '/logout', element: <AccountLogout /> },
    // healthcare
    { path: '/healthcare', element: <HealthCareHome /> },
    { path: '/healthcare/application', element: <ApplicationSection /> },
    { path: '/healthcare/application/list', element: <AdminHealthCareFormList /> },
    { path: '/healthcare/heightchart', element: <HealthcareHeightChart /> },
    // fitness
    { path: '/fitness/result', element: <FitnessResult /> },
    // payment, bill
    { path: '/payment', element: <PaymentHome /> },
    { path: '/bill/:bill_id', element: <BillStatusPage /> },
    { path: '/bill/result', element: <BillResultComponent /> },
    // invitaion
    { path: '/inv', element: <Invitation /> },
    { path: '/inv/success', element: <AcceptInvitation /> },
    // admin
    { path: '/adminlogin/A2k!jvI2', element: <AdminLogin /> },
    // temporary
    { path: '/service/temporary', element: <Temporary /> },
    // policy
    { path: '/policy/privacy', element: <Privacy /> },
    // QR attendance
    { path: '/qr/login', element: <QrAttendanceLogin /> },
    // promotion
    { path: '/promotion/certificate', element: <PromotionCertificate /> },
    // terms
    { path: '/terms/tkw', element: <TkwTerms /> },
    { path: '/terms/personal', element: <PersonalTerms /> },
    { path: '/terms/location', element: <LocationTerms /> },
    { path: '/terms/marketing', element: <MarketingTerms /> },
  ],
  noLayoutLogin: [
    // QR attendance
    { path: '/qr/reg', element: <QrAttendanceRegist /> },
  ],
  onlyTopbar: [
    // account
    { path: '/account/sign', element: <AccountSign /> },
    { path: '/account/sign/kwanjang', element: <AccountSignKwanjang /> },
    { path: '/account/sign/sabum', element: <AccountSignSabum /> },
    { path: '/account/sign/student', element: <AccountSignStudent /> },
    { path: '/account/sign/parent', element: <AccountSignParent /> },
    { path: '/account/find/username', element: <FindUserName /> },
    { path: '/account/find/password', element: <FindUserPW /> },
    // sportsent notice
    { path: '/sportsent/notice', element: <SportsentNotice /> },
  ],
  onlyTopbarWithLogout: [
    // account
    { path: '/account/myinfo', element: <MypageAccount /> },
    { path: '/account/resume', element: <MypageResume /> },
  ],
};

export default commonRoutes;
